import(/* webpackMode: "eager", webpackExports: ["default"] */ "/builds/devteam/iconosquare/icofrontend/node_modules/next-intl/dist/esm/production/shared/NextIntlClientProvider.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/builds/devteam/iconosquare/icofrontend/src/app/AppRouterTools.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ClientProviders"] */ "/builds/devteam/iconosquare/icofrontend/src/app/ClientProviders.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["FlagsmithProviderWrapper"] */ "/builds/devteam/iconosquare/icofrontend/src/app/FlagsmithProviderWrapper.tsx");
;
import(/* webpackMode: "eager" */ "/builds/devteam/iconosquare/icofrontend/src/components/base/Tooltip/TooltipContext.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TooltipFloating"] */ "/builds/devteam/iconosquare/icofrontend/src/components/base/Tooltip/TooltipFloating.tsx");
;
import(/* webpackMode: "eager" */ "/builds/devteam/iconosquare/icofrontend/src/styles/styles.css");
;
import(/* webpackMode: "eager" */ "/builds/devteam/iconosquare/icofrontend/public/fonts/fonticon/style.css");
;
import(/* webpackMode: "eager", webpackExports: ["GlobalInfoProvider"] */ "/builds/devteam/iconosquare/icofrontend/src/utils/hooks/context/useGlobalInfo.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["LoggedInStoreProvider"] */ "/builds/devteam/iconosquare/icofrontend/src/utils/zustand/providers/logged-in-provider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ProfilesStoreProvider"] */ "/builds/devteam/iconosquare/icofrontend/src/utils/zustand/providers/profiles-provider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SignUpStoreProvider"] */ "/builds/devteam/iconosquare/icofrontend/src/utils/zustand/providers/sign-up-provider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ToggleLayoutPlatformProvider"] */ "/builds/devteam/iconosquare/icofrontend/src/utils/zustand/providers/toggle-layout-platform-provider.tsx");
